
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { SimpleNotificationsModule, SimpleNotificationsComponent } from 'angular2-notifications';
import { SpinnerService } from './spinner/spinner.service';
import { SpinnerComponent } from './spinner/spinner.component';
import { NgxLoadingModule } from 'ngx-loading';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CurrentPageWatcherService } from './utils/CurrentPageWatcher';
import { MessageCenter } from './utils/MessagesCenter';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtIntereptorService } from './security/jwt-intereptor.service';
import { AuthGuard } from './security/auth.guard';
import { LoadingComponent } from './utils/loading/loading/loading.component';
import { JasperoAlertsModule, AlertsComponent } from '@jaspero/ng2-alerts';
import { PipeModule } from './pipes/pipe.module';
import { Error404Component } from './errors/error404/error404.component';
import { IdleService } from './idle/idle.service';
import { StartFunctionService } from './utils/start-function.service';
import { CompleteFunctionService } from './utils/complete-function.service';
import { HelpComponent } from './help/help.component';
import { FaqComponent } from './faq/faq.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { StepMessageContentComponent } from './utils/step-message-content/step-message-content.component';
import { DynamicContentComponent } from './utils/dynamic-content/dynamic-content.component';
import { PaymentModule } from './payment/payment.module';
import { NgxPrintModule } from 'ngx-print';
import { PdfStream } from './pdfStream';
import { StringUtils } from './utils/stringUtils';
  
@NgModule({
  imports: [
    PaymentModule, 
    JasperoAlertsModule, 
    CommonModule,
    HttpModule,
    SimpleNotificationsModule.forRoot(), 
    PipeModule.forRoot(),
    HttpModule,
    FormsModule, 
    NgxLoadingModule,
    NgbModule.forRoot(), 
    NgxPrintModule
  ],
  exports: [
    AlertsComponent, 
    LoadingComponent,
    SimpleNotificationsComponent, 
    NgxLoadingModule,
    SpinnerComponent,
    FormsModule,
    CommonModule,  
    NgbModule,
    PipeModule, 
    StepMessageContentComponent,
    DynamicContentComponent
  ],
  declarations: [ 
    SpinnerComponent, 
    LoadingComponent, 
    Error404Component,
    HelpComponent, 
    FaqComponent, 
    PrivacyPolicyComponent, 
    StepMessageContentComponent, 
    DynamicContentComponent 
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtIntereptorService, multi: true },
    AuthGuard,
    PdfStream,
    StringUtils,
    SpinnerService, 
    CurrentPageWatcherService,
    MessageCenter, 
    IdleService, 
    StartFunctionService, 
    CompleteFunctionService
  ]
})
export class PTLSharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts